import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from '@chakra-ui/react';

const NotFoundContent = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 6px;

    .notfound-icon {
        width: 84px;
        margin-bottom: 16px;
    }

    h1 { 
        font-size: 32px;
        font-weight: 600;
    }

    p {
        font-size: 16px;
    }

    @media screen and (max-width: 600px) {
        
        h1 { 
            font-size: 28px;
        }

        p {
            font-size: 14px;
        }
    
        .notfound-icon {
            width: 60px;
        }
    }
`;

const NotFoundIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6274_103290)">
      <path
        d="M83.4258 79.0108L62.2567 57.8545C62.0757 57.6698 61.8591 57.5237 61.62 57.425C61.381 57.3263 61.1244 57.277 60.8658 57.2803H59.1815C65.2443 50.7163 68.4916 42.0367 68.2258 33.1052C67.96 24.1736 64.2025 15.7024 57.7601 9.51054C51.3177 3.31871 42.7041 -0.0999479 33.7691 -0.011351C24.834 0.077246 16.29 3.66602 9.97161 9.98438C3.65325 16.3027 0.0643981 24.8468 -0.0241989 33.7819C-0.112796 42.7169 3.30587 51.3305 9.4977 57.7729C15.6895 64.2153 24.1608 67.9729 33.0924 68.2386C42.0239 68.5044 50.7035 65.2571 57.2675 59.1943V60.8659C57.2722 61.3862 57.478 61.8846 57.8417 62.2567L79.0107 83.4258C79.3831 83.7929 79.8851 83.9986 80.408 83.9986C80.9309 83.9986 81.4327 83.7929 81.8052 83.4258L83.4258 81.8053C83.7928 81.4328 83.9986 80.9309 83.9986 80.408C83.9986 79.8851 83.7928 79.3832 83.4258 79.0108ZM34.1205 62.9968C28.4088 62.9968 22.8255 61.3029 18.0765 58.1294C13.3276 54.9559 9.62643 50.4453 7.44123 45.1681C5.25603 39.8909 4.68496 34.0842 5.80018 28.4825C6.91541 22.8807 9.66682 17.7354 13.7065 13.6975C17.7462 9.65964 22.8926 6.91048 28.4949 5.79773C34.0972 4.68498 39.9036 5.25865 45.1798 7.44617C50.456 9.6337 54.965 13.3368 58.1365 18.0872C61.3079 22.8375 62.9993 28.4217 62.9967 34.1334C63.0001 37.9258 62.2554 41.6816 60.8053 45.1859C59.3552 48.6901 57.2281 51.8739 54.5459 54.5549C51.8636 57.236 48.6788 59.3616 45.174 60.8102C41.6691 62.2588 37.913 63.0019 34.1205 62.9968Z"
        fill="white"
      />
      <path
        d="M22.5088 47.6719V19.0381H45.5408V47.3401"
        stroke="#3366FF"
        strokeWidth="3.81"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.8245 24.9588H36.7493C36.2419 24.9588 35.8306 25.3702 35.8306 25.8776V28.9528C35.8306 29.4602 36.2419 29.8715 36.7493 29.8715H39.8245C40.3319 29.8715 40.7432 29.4602 40.7432 28.9528V25.8776C40.7432 25.3702 40.3319 24.9588 39.8245 24.9588Z"
        fill="#3366FF"
      />
      <path
        d="M31.9258 24.9588H28.8506C28.3432 24.9588 27.9319 25.3702 27.9319 25.8776V28.9528C27.9319 29.4602 28.3432 29.8715 28.8506 29.8715H31.9258C32.4332 29.8715 32.8445 29.4602 32.8445 28.9528V25.8776C32.8445 25.3702 32.4332 24.9588 31.9258 24.9588Z"
        fill="#3366FF"
      />
      <path
        d="M39.8245 32.1938H36.7493C36.2419 32.1938 35.8306 32.6052 35.8306 33.1126V36.1878C35.8306 36.6952 36.2419 37.1065 36.7493 37.1065H39.8245C40.3319 37.1065 40.7432 36.6952 40.7432 36.1878V33.1126C40.7432 32.6052 40.3319 32.1938 39.8245 32.1938Z"
        fill="#3366FF"
      />
      <path
        d="M31.9258 32.1938H28.8506C28.3432 32.1938 27.9319 32.6052 27.9319 33.1126V36.1878C27.9319 36.6952 28.3432 37.1065 28.8506 37.1065H31.9258C32.4332 37.1065 32.8445 36.6952 32.8445 36.1878V33.1126C32.8445 32.6052 32.4332 32.1938 31.9258 32.1938Z"
        fill="#3366FF"
      />
      <path
        d="M35.8689 49.1138H32.8065C32.2961 49.1138 31.8877 48.2971 31.8877 47.3019V41.2535C31.8877 40.2582 32.2961 39.4416 32.8065 39.4416H35.8689C36.3793 39.4416 36.7876 40.2582 36.7876 41.2535V47.3019C36.7876 48.2971 36.3793 49.1138 35.8689 49.1138Z"
        fill="#3366FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_6274_103290">
        <rect width="84" height="84" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const NotFound: React.FunctionComponent = () => {
  return (
    <Flex
      bgColor="#001238"
      w="100%"
      minH="100vh"
      justifyContent="center"
      alignItems="center"
      color="white"
    >
      <NotFoundContent>
        <div className="notfound-icon">{NotFoundIcon}</div>
        <h1>Page not found</h1>
        <p>
          Enter URL is not correct
          <br />
          or there is no property with such ID
        </p>
      </NotFoundContent>
    </Flex>
  );
};

export default NotFound;
